module.exports = __webpack_public_path__ + "static/media/om_hairstyle_receding_front.ac5114d5.png";